import app from 'flarum/forum/app';
import PaginatedListState from 'flarum/common/states/PaginatedListState';
export default class ErasureRequestsListState extends PaginatedListState {
  constructor() {
    super({}, 1, null);
  }
  get type() {
    return 'user-erasure-requests';
  }

  /**
   * Load flags into the application's cache if they haven't already
   * been loaded.
   */
  load() {
    if (app.session.user?.attribute('erasureRequestCount')) {
      this.pages = [];
      this.location = {
        page: 1
      };
    }
    if (this.pages.length > 0) {
      return Promise.resolve();
    }
    return super.loadNext();
  }
}
flarum.reg.add('flarum-gdpr', 'forum/states/ErasureRequestsListState', ErasureRequestsListState);